"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _molecules = require("../../molecules");

var _pagination = _interopRequireDefault(require("./pagination"));

var _rows = require("./rows");

var _head = require("./head");

var _utils = require("../../shared/utils");

var _Table = require("./Table.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Table = ({
  columns,
  data,
  loading,
  borderRadius,
  showIndex,
  isSelectable,
  enableSort,
  onRowMouseEnter,
  onRowMouseLeave,
  onRowClick,
  onAllRowSelect,
  rowSelectHandler,
  handleAscendingSort,
  handleDescendingSort,
  handleResetSort,
  showPagination,
  totalRecords,
  perPage,
  handlePagination,
  handleRename,
  handleEditSuccess,
  handleEditCancel,
  rowClassName,
  cellClassName,
  render,
  changedPageNumber,
  tableCaption,
  customHeader,
  activePageNumber,
  collapseOnRowClick,
  hideCaption,
  defaultRowSelection
}) => {
  const addCheckToData = data => {
    if (_lodash.default.isEmpty(data)) return data;
    return data.map(obj => {
      if (checkHasChildren(obj)) {
        const children = obj.children.map(child => !_lodash.default.has(child, '_isCheck') ? { ...child,
          _isCheck: false
        } : child);
        return !_lodash.default.has(obj, '_isCheck') ? { ...obj,
          children,
          _isCheck: false,
          _isPartial: false
        } : { ...obj,
          children
        };
      }

      return !_lodash.default.has(obj, '_isCheck') ? { ...obj,
        _isCheck: false,
        _isPartial: false
      } : obj;
    });
  };

  const [tableData, setTableData] = (0, _react.useState)(() => addCheckToData(data));
  showIndex = isSelectable ? true : showIndex;
  const [page, setPage] = (0, _react.useState)(activePageNumber);
  const [caption, setCaption] = (0, _react.useState)(tableCaption);
  const [sort, setSort] = (0, _react.useState)(() => columns.map(({
    accessor
  }) => ({
    accessor,
    status: -1
  })));
  const [selectAll, setSelectAll] = (0, _react.useState)(false);
  const [isPartial, setIsPartial] = (0, _react.useState)(false);
  const [collapse, setCollapse] = (0, _react.useState)([]);
  const [editText, setEditText] = (0, _react.useState)('');
  const length = data.length;
  (0, _react.useEffect)(() => {
    if (columns[0].children === undefined) {
      setCollapse([]);
    } else {
      if (Array.isArray(columns[0].children)) {
        setCollapse(Array.from({
          length
        }).fill(false));
      } else {
        setCollapse([]);
      }
    }
  }, [columns, setCollapse, length]);
  (0, _react.useEffect)(() => {
    const transformedData = addCheckToData(data);
    setTableData(transformedData);
  }, [data]);
  (0, _react.useEffect)(() => {
    setPage(activePageNumber);
  }, [activePageNumber]);
  (0, _react.useEffect)(() => {
    setSort(columns.map(({
      accessor
    }) => ({
      accessor,
      status: -1
    })));
  }, [columns, caption]);
  (0, _react.useEffect)(() => {
    resetCollapse(setCollapse);
    resetAllCheck(setTableData);
  }, [changedPageNumber]);
  (0, _react.useEffect)(() => {
    setSelectAll(tableData.some(obj => {
      if (obj._isCheck) return true;

      if (checkHasChildren(obj)) {
        return obj.children.some(child => child._isCheck === true);
      }
    }));
  }, [tableData]);
  (0, _react.useEffect)(() => {
    setIsPartial(selectAll && tableData.some(obj => {
      if (!obj._isCheck) return true;

      if (checkHasChildren(obj)) {
        return obj.children.some(child => child._isCheck === false);
      }
    }));
  }, [selectAll, tableData]);

  const handleSort = (key, id) => {
    setTableData(data);
    resetCollapse(setCollapse);

    if (sort[id].status === -1) {
      setSort(arr => arr.map(obj => obj.accessor === key ? { ...obj,
        status: 0
      } : { ...obj,
        status: -1
      }));
      handleAscendingSort(key, data, setTableData);
    } else if (sort[id].status === 0) {
      setSort(arr => arr.map(obj => obj.accessor === key ? { ...obj,
        status: 1
      } : { ...obj,
        status: -1
      }));
      handleDescendingSort(key, data, setTableData);
    } else if (sort[id].status === 1) {
      setSort(arr => arr.map(obj => obj.accessor === key ? { ...obj,
        status: -1
      } : { ...obj,
        status: -1
      }));
      handleResetSort(key, data, setTableData);
    }
  };

  const handleRowSelection = (0, _react.useCallback)((e, index) => {
    e.persist();
    setTableData(data => data.map((obj, i) => {
      if (i === index) {
        if (checkHasChildren(obj)) {
          const children = [...obj.children].map(child => ({ ...child,
            _isCheck: e.target.checked
          }));
          return { ...obj,
            children,
            _isCheck: e.target.checked,
            _isPartial: false
          };
        }

        return { ...obj,
          _isCheck: e.target.checked
        };
      } else {
        return obj;
      }
    }));
    const data = tableData.filter((_, i) => i === index).map(obj => {
      if (checkHasChildren(obj)) {
        const children = [...obj.children].map(child => ({ ...child,
          _isCheck: e.target.checked
        }));
        return { ...obj,
          children,
          _isCheck: e.target.checked
        };
      }

      return obj;
    })[0];
    (0, _utils.isFunction)(rowSelectHandler) && rowSelectHandler(e, { ...data,
      _isCheck: e.target.checked
    });
  }, [setTableData, tableData]);
  const handleChildRowSelection = (0, _react.useCallback)((e, data, parentIndex, childIndex) => {
    e.persist();
    setTableData(data => data.map((obj, i) => {
      if (i === parentIndex && checkHasChildren(obj)) {
        obj.children.map((child, j) => {
          if (j === childIndex) {
            child._isCheck = e.target.checked;
          }

          return child;
        });
        const isPartial = obj.children.some(child => child._isCheck === false);
        obj._isPartial = isPartial;
        obj._isCheck = obj.children.some(child => child._isCheck === true);
      }

      return obj;
    }));
    (0, _utils.isFunction)(rowSelectHandler) && rowSelectHandler(e, { ...data,
      _isCheck: e.target.checked
    });
  }, [setTableData, tableData]);
  const checkColumnHasChild = (0, _react.useCallback)(id => {
    if (columns[0].children !== undefined) {
      if (tableData.length !== 0 && tableData[id].children !== undefined) {
        return Array.isArray(tableData[id].children) && tableData[id].children.length !== 0 ? true : false;
      }

      return false;
    }

    return false;
  }, [columns, tableData]);

  const handleSelectAll = e => {
    let isSelectedAll;

    if (!selectAll) {
      setSelectAll(v => !v);
      setTableData(data => data.map(obj => {
        if (checkHasChildren(obj)) {
          const children = obj.children.map(child => ({ ...child,
            _isCheck: true
          }));
          return { ...obj,
            children,
            _isCheck: true,
            _isPartial: false
          };
        }

        return { ...obj,
          _isCheck: true
        };
      }));
      isSelectedAll = true;
    } else {
      setSelectAll(false);
      setTableData(data => data.map(obj => {
        if (checkHasChildren(obj)) {
          const children = obj.children.map(child => ({ ...child,
            _isCheck: false
          }));
          return { ...obj,
            children,
            _isCheck: false,
            _isPartial: false
          };
        }

        return { ...obj,
          _isCheck: false
        };
      }));
      isSelectedAll = false;
    }

    (0, _utils.isFunction)(onAllRowSelect) && onAllRowSelect(e, isSelectedAll);
  };

  const handleRowClick = (e, obj) => (0, _utils.isFunction)(onRowClick) && onRowClick(e, obj);

  const handleRowCollapse = id => id !== undefined && checkColumnHasChild(id) && handleCollapse(id, setCollapse);

  const handleRowMouseEnter = (e, id) => (0, _utils.isFunction)(onRowMouseEnter) && onRowMouseEnter(e, tableData[id], false, setTableData);

  const handleRowMouseLeave = (e, id) => (0, _utils.isFunction)(onRowMouseLeave) && onRowMouseLeave(e, tableData[id], false, setTableData);

  const onPageChange = id => {
    setPage(id);
    (0, _utils.isFunction)(handlePagination) && handlePagination(id);
  };

  const loaderColumns = columns.filter(col => col.title !== '\u00a0').map(col => col.title);

  if ((0, _utils.isFunction)(render) && render({
    data: tableData
  }) === null) {
    if (loading) {
      return /*#__PURE__*/_react.default.createElement(_molecules.TableLoader, {
        "data-testid": "table-loader",
        theme: "light",
        columns: loaderColumns,
        rowCount: perPage
      });
    }
  }

  return /*#__PURE__*/_react.default.createElement(_Table.StyledTable, {
    isSelectable: isSelectable,
    showIndex: showIndex,
    caption: caption,
    borderRadius: borderRadius,
    hideCaption: hideCaption
  }, (0, _utils.isFunction)(customHeader) ? customHeader({
    columns,
    sortArray: sort,
    handleSort
  }) : /*#__PURE__*/_react.default.createElement(_head.Head, {
    columns: columns,
    isSelectable: isSelectable,
    showIndex: showIndex,
    enableSort: enableSort,
    selectAll: selectAll,
    collapse: collapse,
    sort: sort,
    handleSelectAll: handleSelectAll,
    handleSort: handleSort,
    isPartialCheck: isPartial
  }), (0, _utils.isFunction)(render) && render({
    data: tableData
  }) !== null ? render({
    data: tableData
  }) : /*#__PURE__*/_react.default.createElement("tbody", null, Array.isArray(tableData) && tableData.length !== 0 && tableData.map((obj, i) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, !_lodash.default.has(obj, '_rename') ? /*#__PURE__*/_react.default.createElement(_rows.Row, {
      columns: columns,
      showIndex: showIndex,
      isSelectable: isSelectable,
      collapse: collapse,
      collapseOnRowClick: collapseOnRowClick,
      data: obj,
      index: i,
      checkColumnHasChild: checkColumnHasChild,
      handleRowClick: handleRowClick,
      handleRowCollapse: handleRowCollapse,
      handleRowMouseEnter: handleRowMouseEnter,
      handleRowMouseLeave: handleRowMouseLeave,
      handleRowSelection: handleRowSelection,
      handleRename: handleRename,
      rowClassName: rowClassName,
      cellClassName: cellClassName
    }) : /*#__PURE__*/_react.default.createElement(_rows.EditRow, {
      "data-testid": "edit-row",
      data: obj,
      columns: columns,
      showIndex: showIndex,
      editText: editText,
      setEditText: setEditText,
      handleEditSuccess: handleEditSuccess,
      handleEditCancel: handleEditCancel,
      isEditRow: true
    }), !_lodash.default.has(obj, '_rename') && collapse[i] && obj.children.length > 0 && obj.children !== undefined && /*#__PURE__*/_react.default.createElement(_rows.ChildRow, {
      columns: columns,
      data: obj,
      isCollapse: collapse.length !== 0,
      showIndex: showIndex,
      isSelectable: isSelectable,
      parentIndex: i,
      handleChildRowSelection: handleChildRowSelection,
      rowClassName: rowClassName,
      cellClassName: cellClassName,
      isParentSelected: obj._isCheck && !obj._isPartial && !defaultRowSelection,
      handleRowClick: handleRowClick,
      onRowMouseEnter: onRowMouseEnter,
      onRowMouseLeave: onRowMouseLeave
    }));
  })), /*#__PURE__*/_react.default.createElement("tfoot", null, showPagination && /*#__PURE__*/_react.default.createElement(_Table.StyledRow, {
    className: "table-main-row"
  }, /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    colSpan: showIndex ? columns.length + 2 : columns.length + 1,
    isfooter: true
  }, /*#__PURE__*/_react.default.createElement(_pagination.default, {
    totalRecords: tableData.length && totalRecords,
    perPage: perPage,
    activePageNumber: page,
    handlePagination: onPageChange,
    setCaption: setCaption,
    onClick: () => {
      resetCollapse(setCollapse);
      resetAllCheck(setTableData);
    }
  })))));
};

exports.Table = Table;
Table.defaultProps = {
  loading: false,
  borderRadius: '4px 4px 0 0',
  showIndex: false,
  isSelectable: false,
  enableSort: false,
  showPagination: false,
  tableCaption: '',
  collapseOnRowClick: true,
  handleAscendingSort: (accessor, data, callback) => {
    const result = [...data].sort((a, b) => a[accessor] > b[accessor] ? 1 : -1);
    callback(result);
  },
  handleDescendingSort: (accessor, data, callback) => {
    const result = [...data].sort((a, b) => a[accessor] < b[accessor] ? 1 : -1);
    callback(result);
  },
  handleResetSort: (accessor, data, callback) => {
    callback(data);
  },
  render: () => {
    return null;
  },
  rowClassName: '',
  cellClassName: '',
  activePageNumber: 1,
  hideCaption: false,
  defaultRowSelection: false
};
Table.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** show/hide table loader using loading (true/false) */
  loading: _propTypes.default.bool,

  /** set table border radius */
  borderRadius: _propTypes.default.string,

  /** show/hide row index column (true/false) */
  showIndex: _propTypes.default.bool,

  /** show/hide checkbox in row using isSelectable (true/false) */
  isSelectable: _propTypes.default.bool,

  /** enable/disable sorting for all columns */
  enableSort: _propTypes.default.bool,

  /** row handler for mouse enter, (event,rowdata,isChild)=>{} */
  onRowMouseEnter: _propTypes.default.func,

  /** row handler for mouse leave, (event,rowdata,isChild)=>{} */
  onRowMouseLeave: _propTypes.default.func,

  /** handler for selecting all rows, (event,isSelected)=>{} */
  onAllRowSelect: _propTypes.default.func,

  /** handler for row click (event,rowData)=>{ }*/
  onRowClick: _propTypes.default.func,

  /** handler for checkbox selection for each row (event,rowData)=>{ }*/
  rowSelectHandler: _propTypes.default.func,

  /** handler for ascending sort */
  handleAscendingSort: _propTypes.default.func,

  /** handler for descending sort */
  handleDescendingSort: _propTypes.default.func,

  /** handler for resetting sort state */
  handleResetSort: _propTypes.default.func,

  /** show/hide pagination */
  showPagination: _propTypes.default.bool,
  totalRecords: _propTypes.default.number,
  perPage: _propTypes.default.number,

  /** handler for page change, (pageIndex)=>{} */
  handlePagination: _propTypes.default.func,
  activePageNumber: _propTypes.default.number,
  rowClassName: _propTypes.default.string,
  cellClassName: _propTypes.default.string,

  /** handler for rename option in menu,
   * handler is available as parameter in render.
   * compare the parameter with the table data and add
   * _rename property to it to enter into edit mode.
   */
  handleRename: _propTypes.default.func,

  /** handler for edit success,
   * (event,rowData,editText)=>{},
   * delete _rename key from the object to exit the
   * edit mode.
   */
  handleEditSuccess: _propTypes.default.func,

  /** handler for canceling edit.
   * (event,rowData)=>{},
   * delete _rename key from the object to exit the
   * edit mode.
   */
  handleEditCancel: _propTypes.default.func,

  /** {({data})=>{
   * 	return custom component or null`
   * }
   * */
  customHeader: _propTypes.default.func,

  /** render prop for custom table body render={({data})=> return table body} */
  render: _propTypes.default.func,
  changedPageNumber: _propTypes.default.number,

  /** set table caption when using pagination as separate component */
  tableCaption: _propTypes.default.string,

  /** collapse child rows on parent row click,(true/false) */
  collapseOnRowClick: _propTypes.default.bool,

  /** hide table caption(true/false) */
  hideCaption: _propTypes.default.bool,

  /** set true for default row selection with _isCheck:true in row data object or else set false */
  defaultRowSelection: _propTypes.default.bool
};

const handleCollapse = (id, callback) => {
  callback(arr => arr.map((v, i) => id === i ? !v : false));
};

const resetCollapse = callback => callback(arr => arr.map(() => false));

const resetAllCheck = callback => callback(arr => arr.map(obj => {
  obj._isCheck = false;
  return obj;
}));

const checkHasChildren = obj => obj.children && !_lodash.default.isEmpty(obj.children);